import React from 'react';
import './NavigationHeader.css';
import { useLocation } from "react-router-dom";
import { Link } from 'react-router-dom';
import { NavigationMenu } from './NavigationMenu';
import { useUserContext } from '../../contexts/UserContext';
import akLogo from '../../images/logo.png';
import alkaNexusLogo from '../../images/AlkaNexus_logo.png';

export const NavigationHeader: React.FC = () => {

    const pathname = useLocation().pathname;
    const userContext = useUserContext();

    const logout = async () => {
        await userContext.logout();
        window.location.href = '/';
    };

    return (
        <header className="PageHeader_header">
            <div className="PageHeader_logo">
                <img className="PageHeader_image_alkanexus_logo" src={alkaNexusLogo} />
                <img className="PageHeader_image_ak_logo" src={akLogo} />
            </div>
            <div className="PageHeader_title">
                {
                    pathname == "/" &&
                    <>
                        <span>Chlor-alkali&nbsp;solutions</span>
                    </>
                }
                {
                    pathname == "/calcce" &&
                    <>
                        {/* 商標を伏せるためサービス名変更 */}
                        {/* <div className="PageHeader_name"><span>Online CE</span></div> */}
                        <div className="PageHeader_name"><span>CE&nbsp;Calculation&nbsp;Service</span></div>
                    </>
                }
                {
                    pathname == "/calcap" &&
                    <>
                        {/* 商標を伏せるためサービス名変更 */}
                        {/* <div className="PageHeader_name"><span>A-Proof</span><span className="PageHeader_title_super">TM</span></div> */}
                        <div className="PageHeader_name"><span>Current&nbsp;Optimization&nbsp;Service</span></div>
                    </>
                }
            </div>
            <nav>
                <ul className="PageHeader_nav">
                    {userContext.isLoggedIn ? (
                        <React.Fragment>
                            <li> <NavigationMenu /> </li>
                            <li> {userContext.userName} </li>
                            <li>
                                <Link to="#" onClick={logout}>Logout</Link>
                            </li>
                        </React.Fragment>
                    ) : (
                        <li>
                            <Link to="/">top</Link>
                        </li>
                    )}
                </ul>
            </nav>
        </header>
    );
};
